import React from 'react'
import PropTypes from 'prop-types'
import apiCompanies from "../features/configuration/services/company"
import useAuthStore from '../stores/authStore'
const MenuItemsCounterContext = React.createContext()

function MenuItemsCounterProvider({ children }) {
  const [menuItemsCounter, setMenuItemsCounter] = React.useState(null)
  const { companyId } = (useAuthStore.getState().identity || {})

  const fetchMenuItemsCounters = React.useCallback(async () => {
    try {
      if (!companyId) return
      const res = await apiCompanies.getMenuItemCount()
      setMenuItemsCounter({
        jobRequests: res?.jobRequests || 0,
        hiringRequests: res?.hiringRequests || 0,
        pendingEvalForms: res?.pendingEvalForms || 0,
        unreadWhatsappCount: res?.unreadWhatsappCount || 0,
        pendingOffers: res?.pendingOffers || 0,
        pendingAssessments: res?.pendingAssessments || 0,
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch notification counters:', error)
      setMenuItemsCounter({
        jobRequests: 0,
        hiringRequests: 0,
        pendingEvalForms: 0,
        unreadWhatsappCount: 0,
        pendingOffers: 0,
        pendingAssessments: 0,
      })
    }
  }, [])
  const contextValue = React.useMemo(
    () => ({
      menuItemsCounter,
      setMenuItemsCounter,
      updateMenuItemsCounters: fetchMenuItemsCounters,
    }),
    [menuItemsCounter],
  )

  React.useEffect(() => {
    fetchMenuItemsCounters()
  }, [])

  return (
    <MenuItemsCounterContext.Provider value={contextValue}>
      {children}
    </MenuItemsCounterContext.Provider>
  )
}

MenuItemsCounterProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { MenuItemsCounterContext, MenuItemsCounterProvider }
